export const HIERARCHY:any={
    1:{name:'choose_portfolio'},
    2:{name:'Choose_program'},
    3:{name:'choose_project'}
}